import { inject, Injectable } from '@angular/core';
import { StorageService as AppStorageService } from '@src/app/modules/auth';

import { StorageKeys } from '../types';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private readonly appStorage = inject(AppStorageService);

  setFirstDeviceLogin() {
    this.appStorage.setItem(StorageKeys.FirstDeviceLogin, new Date().toDateString());
  }

  isFirstDeviceLogin() {
    return !this.appStorage.getItem(StorageKeys.FirstDeviceLogin);
  }
}
